import React, { createContext, useContext } from 'react';

export type FeatureFlags = {
  machineInspector: boolean;
};

export const FeatureFlagContext = createContext<FeatureFlags | null>(null);

export const FeatureFlagContextProvider = ({ children, flags }: { children: React.ReactNode; flags: FeatureFlags }) => {
  return <FeatureFlagContext.Provider value={flags}>{children}</FeatureFlagContext.Provider>;
};

export const useFeatureFlagContext = () => {
  const value = useContext(FeatureFlagContext);

  if (!value) throw new Error('FeatureFlagContext is required');

  return value;
};
